import React from 'react'

const RealtimeAdvertisingHero = () => {
    return (
        <section className="lg:py-28 lg:px-12 px-5  py-28 bg-bgDefault text-white ">
            <div className='container xl:mx-auto xl:max-w-screen-xl'>
                <div className='grid grid-cols-12 gap-8'>
                    <div className='col-span-12 md:col-span-6'>
                        <h2 className="text-heading-4 lg:text-heading-1 font-dmsans font-bold tracking-[-0.06em] mb-8 ">
                            Real-Time Online Advertising Platform
                        </h2>
                         <div className="flex flex-wrap gap-2 mt-2 mb-6">
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Spring Boot
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Angular
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Amazon SQS
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                MySQL
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Redis
                            </span>
                        </div>
                         <p className="text-[#9E9E9E] mb-6 text-base md:text-body font-roboto ">
                              We partnered with a leading Australian advertising and media company to architect a high-performance
                              real-time advertising analytics platform that processes millions of campaign interactions daily. Built with
                              Spring Boot, Angular, and Amazon SQS, the solution delivers instant campaign insights, automated reporting
                              that reduced manual analysis time by 50%, and real-time dashboard updates with sub-second latency. Leveraging
                              MySQL for persistent storage and Redis for caching, the platform handles massive data streams without performance
                              degradation, enabling advertisers to optimize campaigns for maximum ROI through data-driven decision-making.
                            </p>

                    </div>
                    <div className='col-span-12 md:col-span-6'>
                      <img src='/case_studies/title-banner/advertising-banner.png' alt='Real-Time Online Advertising Platform' className='w-full h-auto'></img>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default RealtimeAdvertisingHero
